module.exports = __webpack_public_path__ + "img/PatrickStuedemann_140x140_rund.7303d6d6.jpg";